"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-martino-del-lago": {
    "140387ad": [{
      "hkey": "b9ee3767",
      "slug": "villa-talamazzi",
      "name": "Villa Talamazzi",
      "primary": true,
      "skipSearch": false
    }],
    "villa-tolemazzi": [{
      "hkey": "b9ee3767",
      "slug": "villa-talamazzi",
      "name": "Villa Talamazzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;